// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"785754f6","488":"6c6b1df8"}[chunkId] + ".chunk.js";
};